import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getComposeStore } from 'owa-calendar-compose-store-manager';

export function getComposeEvent(): CalendarEvent {
    let composeStore = getComposeStore();
    if (composeStore.openedForm != null) {
        return composeStore.event;
    }
    return null;
}
